import type { CollectionField, RecordData } from '@grc/types';

/**
 * Render a record field value for tables/read views (mirrors the worker's
 * formatter). `recordNames` resolves `record` field ids — the list and detail
 * endpoints return them as `refs`.
 */
export function formatFieldValue(
  field: CollectionField,
  value: unknown,
  memberNames: ReadonlyMap<string, string>,
  recordNames: ReadonlyMap<string, string>,
): string {
  if (value === undefined || value === null || value === '') return '—';
  switch (field.type) {
    case 'boolean':
      return value === true ? 'Yes' : 'No';
    case 'multiselect':
      return Array.isArray(value) && value.length > 0 ? (value as string[]).join(', ') : '—';
    case 'member':
      return memberNames.get(value as string) ?? 'Former member';
    case 'record':
      return recordNames.get(value as string) ?? '(record deleted)';
    default:
      return String(value);
  }
}

/** Required fields of one step that are missing from `data` (client-side mirror of server validation). */
export function missingRequired(
  fields: CollectionField[],
  data: RecordData,
): Record<string, string> {
  const errors: Record<string, string> = {};
  for (const f of fields) {
    if (!f.required) continue;
    const v = data[f.key];
    const empty =
      v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
    if (empty) errors[f.key] = `${f.label} is required`;
  }
  return errors;
}
